// extracted by mini-css-extract-plugin
module.exports = {"wrap":"App_wrap__1qZn7","menu":"App_menu__iWcXQ","link":"App_link__19dol","school_img":"App_school_img__2-JB5"};